/*
 * COPYRIGHT (c) 2023
 * HONEYWELL INC.,
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Button, Card, Checkbox, Divider, Icon, Popup } from '@scuf/common';
import React from 'react';
import './ColumnSelectorComponent.scss';
import useFilter from './useFilter';
import { useTranslation } from '@scuf/localization';
import descriptors from '../../../../locales/en-US/descriptors';
import { ISummaryTableColumn } from './SummaryTable';

interface IColumnSelectorComponentProps {
  onApply: (filteredData: ISummaryTableColumn[]) => void;
  data: ISummaryTableColumn[];
}
function ColumnSelectorComponent(props: IColumnSelectorComponentProps) {
  const [t] = useTranslation();
  const d = descriptors.energyManagement;

  const {
    isOpen,
    data: columns,
    onCheckboxClick,
    hidePopup,
    handleOpen,
    applyOnClick,
    cancelOnClick
  } = useFilter(props);

  return (
    <Popup
      className="summary-table-menu-element"
      element={<Icon root="common" name="filter1" size="medium" />}
      hoverable={false}
      position="bottom right"
      on="click"
      open={isOpen}
      onOpen={handleOpen}
      onClose={hidePopup}
    >
      <Card className="filter-popup">
        <Card.Header title={t(d.MANAGE_COLUMNS)} />
        <Divider className="header-divider" fitted={false} />
        <Card.Content className="popup-content">
          {columns.map((element: ISummaryTableColumn) => (
            <Checkbox
              key={element.field}
              label={element.header}
              checked={element.isSelected}
              onChange={(checked) => onCheckboxClick(checked, element, 'field')}
            />
          ))}
        </Card.Content>
        <Card.Footer>
          <Button
            type="secondary"
            size="small"
            className="cancel-btn action-btn"
            onClick={cancelOnClick}
            content={t(d.CANCEL)}
          />
          <Button
            // disabled={
            //   !columns.filter((item: ISummaryTableColumn) => item.isSelected)
            //     .length
            // }
            type="primary"
            size="small"
            className="apply-btn action-btn"
            onClick={applyOnClick}
            content={t(d.APPLY)}
          />
        </Card.Footer>
      </Card>
    </Popup>
  );
}

export default ColumnSelectorComponent;
